import { render } from "./AuthMaster.vue?vue&type=template&id=09835b28"
import script from "./AuthMaster.vue?vue&type=script&lang=js"
export * from "./AuthMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__